import { ContactType } from '../../../contacts/types/contactType'
import { EInvoiceIneligibilityReason } from '../../enums/eInvoiceIneligibilityReason'
import { ZervantContactType } from '../../enums/zervantContactType'

interface GetEInvoiceIneligibilityReasonsOptions {
  contactCountry?: string | null
  contactType?: ZervantContactType | ContactType
  isCustomerPublicEntity?: boolean
}

export const getEInvoiceIneligibilityReasons = ({
  contactCountry,
  contactType,
  isCustomerPublicEntity,
}: GetEInvoiceIneligibilityReasonsOptions): EInvoiceIneligibilityReason[] => {
  const isCompanyContact = contactType === ZervantContactType.Company || contactType === ContactType.Company
  const reasons: EInvoiceIneligibilityReason[] = []

  if (!isCompanyContact) {
    reasons.push(EInvoiceIneligibilityReason.ClientNotCompany)
  }
  if (isCustomerPublicEntity) {
    reasons.push(EInvoiceIneligibilityReason.ClientNotPrivate)
  }
  if (contactCountry !== 'FR') {
    reasons.push(EInvoiceIneligibilityReason.ClientNotFrench)
  }

  return reasons
}
